import React from 'react';
import UnifiedMessageCustomerModal from './UnifiedMessageCustomerModal';
import { sendMt5PushToCustomers } from '../../../services/BackendService';
import { ICustomer } from '../types';

interface IProps {
  show: boolean;
  onClose: () => void;
  onCloseDiscardChanges: () => void;
  customer: ICustomer;
}

const Mt5PushCustomerModal = ({ show, onClose, onCloseDiscardChanges, customer }: IProps) => {
  return (
    <UnifiedMessageCustomerModal
      show={show}
      onClose={onClose}
      onCloseDiscardChanges={onCloseDiscardChanges}
      customer={customer}
      titleKey="customer.send-mt5-push-to"
      successToastKey="customer.mt5-push-sent-to-customer"
      inputId="mt5-push-message"
      showSubject={false}
      useNumericId={true}
      maxLength={1024}
      onSend={({ customerId, message }) => sendMt5PushToCustomers(customerId, message)}
    />
  );
};

export default React.memo(Mt5PushCustomerModal);
